import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SubtitleSettingsModal from '../common/SubtitleSettingsModal';
import { savePendingUpload } from '../../utils/pendingUpload';
import { trackEvent } from '../../utils/analytics';

/* Landing-page wrapper around the shared Subtitle Settings card. Nothing
   uploads here — the file waits in the browser (pendingUpload) and starts
   on its own after signup. */
const UploadPrepModal = ({ file, info, onClose }) => {
  const navigate = useNavigate();
  const [maxWords, setMaxWords] = useState(3);
  const [subtitleLanguage, setSubtitleLanguage] = useState('hinglish');
  const [audioCleanup, setAudioCleanup] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleGenerate = async () => {
    setSaving(true);
    await savePendingUpload(file, { maxWords, subtitleLanguage, audioCleanup });
    trackEvent('landing_generate_clicked', { language: subtitleLanguage });
    navigate('/register');
  };

  return (
    <SubtitleSettingsModal
      file={file}
      info={{ name: file.name, sizeStr: info?.sizeStr, durationStr: info?.durationStr }}
      maxWords={maxWords}
      language={subtitleLanguage}
      onMaxWordsChange={setMaxWords}
      onLanguageChange={setSubtitleLanguage}
      audioCleanup={audioCleanup}
      onAudioCleanupChange={setAudioCleanup}
      onCancel={onClose}
      onConfirm={handleGenerate}
      saving={saving}
      footnote="Free account needed. Nothing uploads until you sign up."
    />
  );
};

export default UploadPrepModal;
